import Router from './router';
import './utils/inject';

function App() {
  return <Router />;
}

export default App;
